<template>
  <CCard>
    <CCardHeader>
      <h2>Add New Gym</h2>
    </CCardHeader>
    <CCardBody>
      <CForm @submit.prevent="saveGym">
        <CInput
          v-model="form.gym_name"
          label="Gym Name"
          :add-input-classes="{ 'is-invalid': hasError('gym_name') }"
          :invalid-feedback="getError('gym_name')"
        />

        <CInput
          v-model="form.email"
          label="Email"
          type="email"
          :add-input-classes="{ 'is-invalid': hasError('email') }"
          :invalid-feedback="getError('email')"
        />

        <div class="mt-3 text-right">
          <CButton
            type="submit"
            color="primary"
          >
            Save
          </CButton>
          <CButton
            type="button"
            color="secondary"
            class="ml-2"
            @click="$router.push('/gyms')"
          >
            Cancel
          </CButton>
        </div>
      </CForm>
    </CCardBody>
  </CCard>
</template>

<script>
import hasApiValidation from "@/mixins/hasApiValidation";

export default {
  name: "AddGym",
  mixins: [hasApiValidation],
  data() {
    return {
      form: {
        gym_name: '',
        email: '',
      },
    };
  },
  methods: {
    saveGym() {
      this.setErrors({});
      this.$http.post('/gym/register-admin', this.form)
        .then(({ data }) => {
          this.$toast.success('Gym added successfully! A password recovery email has been sent.');
          this.$router.push('/gyms');
        })
        .catch(({ response }) => {
          if (response.status === 422 && response.data.errors) {
            this.setErrors(response.data.errors);
          } else {
            this.$toast.error(response.data.message || 'Failed to add gym.');
          }
        });
    },
  }
};
</script>

<style scoped>
.mt-3 { margin-top: 1rem; }
.ml-2 { margin-left: 0.5rem; }
</style>
